import { render } from "./TagConsentView.vue?vue&type=template&id=5a436638"
import script from "./TagConsentView.vue?vue&type=script&lang=js"
export * from "./TagConsentView.vue?vue&type=script&lang=js"

import "./TagConsentView.vue?vue&type=style&index=0&id=5a436638&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__